import React, { FC, useEffect, useLayoutEffect } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import { ResolveThunks, connect, useSelector } from "react-redux";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        session: state.context.session,
    };
};

const mapDispatchToProps = {
    toggleLoginDrawer,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export const ADIMonthlyFlyer = ({ session, toggleLoginDrawer }: Props) => {
    const isAuthenticated = session && (session.isAuthenticated || session.rememberMe) && !session.isGuest;
    const isPendingVerification = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isPendingVerification,
    );
    const isLoading = useSelector((state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore.isLoading);
    if (!isAuthenticated) {
        toggleLoginDrawer({ loginDrawer: true });
    }

    const displayPlaceHolderImageBasedOnAuth = () => {
        if (!isAuthenticated || isPendingVerification) {
            return (
                <>
                    <div id="monthlyflyer">
                        <img
                            src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/landing_pages/MSF/images/MSF-holder-2.jpg"
                            style={{ width: "100%", position: "relative" }}
                        />
                    </div>
                </>
            );
        }
    };

    const displayMonthlySaleOnAuth = () => {
        if (isAuthenticated && !isLoading && !isPendingVerification) {
            return (
                <>
                    <div id="container" style={{ width: "100%", height: "0px", position: "relative" }}></div>
                </>
            );
        }
    };

    return (
        <>
            {displayMonthlySaleOnAuth()}
            {displayPlaceHolderImageBasedOnAuth()}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ADIMonthlyFlyer),
    definition: {
        group: "Common",
        displayName: "ADI Monthly Flyer",
        fieldDefinitions: [],
    },
};

export default widgetModule;
